import axios from 'axios'
import { getToken } from './coreclient'

export default {
  async fillExcel(
    body: unknown,
    useDevFile: boolean = false,
    hiddenTabs?: string,
    deletedTabs?: string
  ) {
    const token = await getToken()

    let url = '/templater/excel'

    if (useDevFile) {
      url += '?useDevFile=true'
    }

    return axios.post(import.meta.env.VITE_API_URL + url, body, {
      responseType: 'blob',
      params: {
        hiddenTabs,
        deletedTabs
      },
      headers: {
        Authorization: `Bearer ${token}`
      }
    })
  }
}
